import Vue from 'vue'
import Vuex from 'vuex'
Vue.use(Vuex)

import createPersistedState from "vuex-persistedstate"
const store = new Vuex.Store({
  state: {
    // 如果上面从本地获取的smWgo对象下有对应的属性，就赋值给state中对应的变量

    //版本信息
    gVer: {},

    smSellAdmin: {
      device_id: '',
      // 商户信息
      shPhone: '', //商户手机号
      shLoadUrl: '', //商户服务器地址
      fwqIp: '', //商户服务器IP
      compName: '', //商户公司名称
      partnerCompName: '', //服务商公司名称
      partnerPhone: '', //服务商手机号
      //登录信息
      userId: '',
      userName: "",
      // 门店信息
      shMallId: '', //门店编码
      shMallName: '', //门店名称
      areaId: '', //区域id
      // 组件时间&门店&供应商
      timeData: [], //时间
      listDateIndex: '', //时间选中的下标
      valueStore: '', //选中门店
      supplier: '', //供应商
      staff: '', //员工
      radio: '', //员工类型 收银员&导购
      vipOption: {}, //会员设置
      systemOption: {}, //系统设置
      payWay: '',
      colorSizeYn: 'N', //是否启用颜色尺码
      canSeeJj: false,
      canSeeMl: false,
    },
    softVer: '', //软件版本
    // smSellAdminToken: '',
    fy_money: '',
    shop_show_payqr_yn: '',
    free_yn: '',
    modifyEdit: {},
  },
  mutations: {
    //
    canSeeJj(state, data) {
      state.smSellAdmin.canSeeJj = data;
    },
    canSeeMl(state, data) {
      state.smSellAdmin.canSeeMl = data;
    },
    compName(state, data) {
      state.smSellAdmin.compName = data;
    },
    vipOption(state, data) {
      state.smSellAdmin.vipOption = data;
    },
    systemOption(state, data) {
      state.smSellAdmin.systemOption = data;
    },
    free_yn(state, data) {
      state.free_yn = data;
    },
    fy_money(state, data) {
      state.fy_money = data;
    },
    create_day(state, data) {
      state.create_day = data;
    },
    ws_yn(state, data) {
      state.ws_yn = data;
    },
    // 储存用户上一次登录手机号
    shPhone(state, data) {
      state.smSellAdmin.shPhone = data;
    },
    device_id(state, data) {
      state.smSellAdmin.device_id = data;
    },
    elabelMchId(state, data) {
      state.smSellAdmin.elabelMchId = data;
    },
    elabelUrl(state, data) {
      state.smSellAdmin.elabelUrl = data;
    },
    shLoadUrl(state, data) {
      state.smSellAdmin.shLoadUrl = data;
    },
    fwqIp(state, data) {
      state.smSellAdmin.fwqIp = data;
    },
    userId(state, data) {
      state.smSellAdmin.userId = data;
    },
    payWay(state, data) {
      state.smSellAdmin.payWay = data;
    },
    colorSizeYn(state, data) {
      state.smSellAdmin.colorSizeYn = data;
    },
    userName(state, data) {
      state.smSellAdmin.userName = data;
    },
    // smSellAdminToken(state, data) {
    //   state.smSellAdminToken = data;
    // },
    partnerPhone(state, data) {
      state.smSellAdmin.partnerPhone = data;
    },
    customEx(state, data) {
      state.smSellAdmin.customEx = data;
    },
    qxList(state, data) {
      state.smSellAdmin.qxList = data;
    },
    shMallName(state, data) {
      state.smSellAdmin.shMallName = data;
    },
    shMallId(state, data) {
      state.smSellAdmin.shMallId = data;
    },
    areaId(state, data) {
      state.smSellAdmin.areaId = data;
    },
    setTimeData(state, data) {
      state.timeData = data;
    },
    setListDateIndex(state, data) {
      state.listDateIndex = data;
    },
    setValueStore(state, data) {
      state.valueStore = data;
    },
    setSupplier(state, data) {
      state.supplier = data
    },
    setStaff(state, data) {
      state.staff = data
    },
    setRadio(state, data) {
      state.radio = data
    },
    NewlyBuild(state, data) {
      state.modifyEdit = data
    },
    softVer(state, data) {
      state.softVer = data
    },
    shop_app_info(state, data) {
      state.smSellAdmin.shop_app_info = data;
    },
    shop_show_payqr_yn(state, data) {
      state.shop_show_payqr_yn = data;
    }

  },
  actions: {

  },
  plugins: [createPersistedState({
    key: 'smSellAdmin'
  })]
})


export default store



// WEBPACK FOOTER //
// ./src/store/index.js